import { create } from 'zustand';

export const topicName = {
  heart: '心臟疾病治療',
  cancer: '癌症質子治療',
};

export const events = [
  {
    topic: topicName.heart,
    date: '08/30',
    titleImage: `${process.env.PUBLIC_URL}/images/heart-title.png`,
    registerOpen: false,
  },
  {
    topic: topicName.cancer,
    date: '09/13',
    titleImage: `${process.env.PUBLIC_URL}/images/cancer-title.png`,
    registerOpen: true,
  },
];

export const videos = [
  {
    topic: topicName.heart,
    src: 'https://player.vimeo.com/video/1151446340',
  },
  {
    topic: topicName.cancer,
    src: 'https://player.vimeo.com/video/1151446314',
  },
];

export const agendas = [
  {
    topic: topicName.heart,
    items: [
      {
        time: '09:00-09:30',
        topic: '報到 + Snapdog 紀念照互動',
        speaker: '',
        position: '',
      },
      {
        time: '09:30-09:40',
        topic: '開場致詞',
        speaker: '程文俊主委',
        position: '長庚醫療財團法人\n決策委員會主任委員',
      },
      {
        time: '09:40-09:45',
        topic: '全體合影',
        speaker: '',
        position: '',
      },
      {
        time: '09:45-10:10',
        topic: '撲通撲通小鹿亂撞 - 漫談心律不整 1',
        speaker: '陳韋翔醫師',
        position: '基隆長庚醫院\n心臟內科電生理科主任/ 助理教授級主治醫師',
      },
      {
        time: '10:10-10:35',
        topic: '心臟衰竭的預防及自我照顧',
        speaker: '潘國利醫師',
        position: '嘉義長庚醫院\n心臟衰竭中心主任/ 副教授級主治醫師',
      },
      {
        time: '10:35-10:45',
        topic: '休息 10 分鐘 + Snapdog 紀念照互動',
        speaker: '',
        position: '',
      },
      {
        time: '10:45-11:10',
        topic: '胸悶痛，我有心臟病嗎？ - 漫談冠狀動脈心臟病',
        speaker: '蕭富致醫師',
        position: '林口長庚醫院\n心臟內科副教授級主治醫師',
      },
      {
        time: '11:10-11:35',
        topic: '我的心臟無力嗎?-漫談心律不整 2',
        speaker: '沃宏達醫師',
        position: '林口長庚醫院\n心臟內科助理教授級主治醫師',
      },
      {
        time: '11:35-12:00',
        topic: '心臟病不只是心臟的事：腎臟、糖尿病與心臟的三角關係',
        speaker: '吳勃銳醫師',
        position: '高雄長庚醫院\n心臟內科助理教授級主治醫師',
      },
      {
        time: '12:00-12:20',
        topic: '閉幕 (包含抽獎活動) + Snapdog 紀念照互動',
        speaker: '',
        position: '',
      },
    ],
  },
  {
    topic: topicName.cancer,
    items: [
      {
        time: '09:00-09:30',
        topic: '報到 + Snapdog 紀念照互動',
        speaker: '',
        position: '',
      },
      {
        time: '09:30-09:40',
        topic: '開場致詞',
        speaker: '林永昌副院長',
        position: '林口長庚醫院',
      },
      {
        time: '09:40-09:45',
        topic: '全體合影',
        speaker: '',
        position: '',
      },
      {
        time: '09:45-10:10',
        topic: '肝癌！不能開！不能燒！怎麼辦？質子治療來解套！',
        speaker: '黃炳勝醫師',
        position: '林口長庚醫院\n放射腫瘤科學術組副教授兼主治醫師',
      },
      {
        time: '10:10-10:35',
        topic: '精準對抗癌症：質子治療在腦瘤與肺癌的應用',
        speaker: '高偉恆醫師',
        position: '林口長庚醫院\n放射腫瘤科學術組助理教授級主治醫師',
      },
      {
        time: '10:35-10:45',
        topic: '休息 10 分鐘 + Snapdog 紀念照互動',
        speaker: '',
        position: '',
      },
      {
        time: '10:45-11:10',
        topic: '攝護腺癌放療新科技，你該怎麼選？',
        speaker: '陳柏叡醫師',
        position: '林口長庚醫院\n放射腫瘤科主治醫師',
      },
      {
        time: '11:10-11:35',
        topic: '鼻咽癌全人全方位精準質子治療',
        speaker: '王友明醫師',
        position: '高雄長庚醫院\n放射腫瘤部主任及副教授/質子暨放射治療中心主任',
      },
      {
        time: '11:35-12:00',
        topic: '化不可能為可能-質子治療跨專科整合治療成效分享',
        speaker: '黃英彥醫師',
        position: '高雄長庚醫院\n放射腫瘤部教授級主治醫師',
      },
      {
        time: '12:00-12:20',
        topic: '閉幕 (包含抽獎活動) + Snapdog 紀念照互動',
        speaker: '',
        position: '',
      },
    ],
  },
];

export const speakers = [
  {
    topic: topicName.heart,
    items: [
      {
        theme: 'orange',
        name: '程文俊 主委',
        organization: '長庚醫療財團法人決策委員會',
        title: '主任委員',
        specialties: ['一般心臟學、高血壓、心臟超音波'],
        position: [
          '長庚醫療財團法人\n決策委員會主任委員',
          '長庚大學醫學院內科教授',
          '總統府國策顧問',
        ],
        education: ['高雄醫學大學醫學系畢業'],
        experience: [
          '林口長庚紀念醫院院長',
          '基隆長庚紀念醫院院長',
          '基隆長庚紀念醫院副院長',
          '林口長庚紀念醫院內科部部主任',
          '基隆長庚紀念醫院內科部部主任',
          '日本國立循環器病中心心臟內科研究員',
          '美國羅徹斯特大學心臟內科研究員',
        ],
        certification: [],
        honors: [
          '高雄醫學大學創辦人杜聰明博士傑出校友獎',
          '全國醫療典範獎',
          '智慧城市卓越貢獻獎',
          '中華民國醫用超音波學會終身成就獎',
          '亞太頂尖永續長獎',
          '國立中山大學講座教授',
        ],
        hr: `${process.env.PUBLIC_URL}/images/hr-1.png`,
        image: `${process.env.PUBLIC_URL}/images/heart-speaker-1.png`,
        imageMobile: `${process.env.PUBLIC_URL}/images/heart-speaker-1-m.png`,
        isOpen: false,
      },
      {
        theme: 'blue',
        name: '陳韋翔 醫師',
        organization: '基隆長庚醫院',
        title: '心臟內科電生理科主任/助理教授級主治醫師',
        specialties: [
          '心導管介入性檢查、心律不整、心臟節律器手術、3D定位電燒、心臟超音波',
        ],
        position: ['基隆長庚心臟內科電生理科主任'],
        education: ['台北醫學大學醫學系'],
        experience: [
          '基隆長庚紀念醫院加護病房主任',
          '基隆長庚紀念醫院心臟內科電生理科主任',
          '基隆長庚紀念醫院心臟內科助理教授級主治醫師',
          '基隆長庚紀念醫院住院醫師',
        ],
        certification: [
          '施行經導管無導線心律調節器置放或置換術認證醫師',
          '施行左心耳封堵術認證醫師',
          '中華民國心臟學會介入性心臟血管專科醫師',
          '中華民國心臟學會專科指導醫師',
          '中華民國心律醫學會',
          '中華民國重症專科',
          '中華民國心臟學會',
          '台灣內科醫學會',
        ],
        honors: [],
        hr: `${process.env.PUBLIC_URL}/images/hr-2.png`,
        image: `${process.env.PUBLIC_URL}/images/heart-speaker-2.png`,
        imageMobile: `${process.env.PUBLIC_URL}/images/heart-speaker-2-m.png`,
        isOpen: false,
      },
      {
        theme: 'blue',
        name: '潘國利 醫師',
        organization: '嘉義長庚醫院',
        title: '心臟衰竭中心主任/副教授級主治醫師',
        specialties: [
          '複雜性心律不整燒灼手術、心律調節器/體內去顫器/雙心室再同步節律器植入手術、心臟衰竭多團隊照護治療、冠狀動脈介入治療',
        ],
        position: [
          '嘉義長庚紀念醫院心臟內科系主任',
          '嘉義長庚紀念醫院心衰竭中心主任',
          '嘉義長庚紀念醫院心臟內科副教授級主治醫師',
          '長庚大學醫學系專任副教授',
        ],
        education: ['台北醫學大學醫學士', '長庚大學臨床醫學研究所碩士'],
        experience: ['嘉義長庚紀念醫院心臟內科專任主治醫師'],
        certification: [
          '中華民國內科專科證書',
          '中華民國心臟內科專科證書',
          '中華民國心臟專科指導證書',
          '中華民國心臟血管介入證書',
          '中華民國重症專科證書',
          '中華民國心臟電生理暨介入性治療專科醫師證書',
          '中華民國輻安證書',
        ],
        honors: [],
        hr: `${process.env.PUBLIC_URL}/images/hr-2.png`,
        image: `${process.env.PUBLIC_URL}/images/heart-speaker-3.png`,
        imageMobile: `${process.env.PUBLIC_URL}/images/heart-speaker-3-m.png`,
        isOpen: false,
      },
      {
        theme: 'blue',
        name: '蕭富致 醫師',
        organization: '林口長庚醫院',
        title: '心臟內科副教授級主治醫師',
        specialties: [
          '心臟血管疾病、介入性心導管治療、心臟血管超音波、週邊血管超音波',
        ],
        position: [
          '林口長庚紀念醫院心臟內科系病房主任',
          '林口長庚紀念醫院心臟內科副教授級主治醫師',
        ],
        education: ['長庚大學醫學系'],
        experience: [
          '林口長庚紀念醫院心臟內科住院醫師',
          '林口長庚紀念醫院內科部住院醫師',
        ],
        certification: ['中華民國心臟學會專科醫師', '台灣內科醫學會'],
        honors: [],
        hr: `${process.env.PUBLIC_URL}/images/hr-2.png`,
        image: `${process.env.PUBLIC_URL}/images/heart-speaker-4.png`,
        imageMobile: `${process.env.PUBLIC_URL}/images/heart-speaker-4-m.png`,
        isOpen: false,
      },
      {
        theme: 'blue',
        name: '沃宏達 醫師',
        organization: '林口長庚醫院',
        title: '心臟內科助理教授級主治醫師',
        specialties: ['心臟血管疾病、心律不整、心臟節律器治療、心臟血管超音波'],
        position: [
          '林口長庚紀念醫院心臟內科主治醫師',
          '林口長庚紀念醫院助理教授級主治醫師',
        ],
        education: ['中國醫藥大學醫學系'],
        experience: [
          '林口長庚紀念醫院心臟內科主治醫師',
          '林口長庚紀念醫院心臟內科醫師研究員',
        ],
        certification: [
          '心臟電生理暨介入治療專科醫師',
          '中華民國心臟學會專科醫師',
          '內科專科醫師',
        ],
        honors: [],
        hr: `${process.env.PUBLIC_URL}/images/hr-2.png`,
        image: `${process.env.PUBLIC_URL}/images/heart-speaker-5.png`,
        imageMobile: `${process.env.PUBLIC_URL}/images/heart-speaker-5-m.png`,
        isOpen: false,
      },
      {
        theme: 'blue',
        name: '吳勃銳 醫師',
        organization: '高雄長庚醫院',
        title: '心臟內科助理教授級主治醫師',
        specialties: ['一般心臟學、心臟超音波、心臟衰竭、心臟重症照護'],
        position: [
          '高雄長庚紀念醫院助理教授級主治醫師',
          '高雄長庚紀念醫院心臟內科加護病房主任',
        ],
        education: ['國立成功大學醫學系'],
        experience: [
          '中華民國醫用超音波醫學會理事 (2024 年  11 月迄今)',
          '台灣心臟學會急重症加護委員 (2024 年 7 月迄今)',
          '高雄長庚紀念醫院住院醫師',
        ],
        certification: [
          '中華民國內科專科證書',
          '中華民國心臟內科專科證書',
          '中華民國心臟血管介入證書',
          '中華民國重症專科證書',
        ],
        honors: [],
        hr: `${process.env.PUBLIC_URL}/images/hr-2.png`,
        image: `${process.env.PUBLIC_URL}/images/heart-speaker-6.png?250806v1`,
        imageMobile: `${process.env.PUBLIC_URL}/images/heart-speaker-6-m.png?250806v1`,
        isOpen: false,
      },
    ],
  },
  {
    topic: topicName.cancer,
    items: [
      {
        theme: 'orange',
        name: '林永昌 副院長',
        organization: '林口長庚醫院',
        title: '',
        specialties: ['乳癌、前列腺癌之藥物治療、腫瘤免疫研究'],
        position: [
          '林口長庚紀念醫院副院長',
          '林口長庚紀念醫院腫瘤科教授級主治醫師',
          '長庚大學醫學院醫學系教授',
          '林口長庚紀念醫院醫教會主席',
        ],
        education: ['台北醫學院醫學系'],
        experience: [
          '林口長庚紀念醫院內科部血液腫瘤科系系主任',
          '林口長庚紀念醫院內科部血液腫瘤科系系主任兼腫瘤科主任',
          '林口長庚紀念醫院內科部血液腫瘤科主治醫師',
          'Clinical fellow, Department of Medical Oncology, UT MD Anderson Cancer Center Houston, USA',
          '林口長庚紀念醫院內科部腫瘤科總醫師',
          '林口長庚紀念醫院內科部住院醫師',
        ],
        certification: ['腫瘤內科專科證書', '內科專科證書'],
        honors: [],
        hr: `${process.env.PUBLIC_URL}/images/hr-1.png`,
        image: `${process.env.PUBLIC_URL}/images/cancer-speaker-1.png`,
        imageMobile: `${process.env.PUBLIC_URL}/images/cancer-speaker-1-m.png`,
        isOpen: false,
      },
      {
        theme: 'blue',
        name: '黃炳勝 醫師',
        organization: '林口長庚醫院',
        title: '放射腫瘤科學術組副教授兼主治醫師',
        specialties: ['肝癌及消化系統腫瘤、鼻咽癌及頭頸部腫瘤、肺癌及胸腔腫瘤'],
        position: [
          '林口長庚紀念醫院副教授級主治醫師',
          '長庚大學醫學系專任助理教授',
          '台灣放射腫瘤學會理事',
        ],
        education: ['長庚大學臨床醫學研究所博士', '中山醫學大學'],
        experience: ['高雄長庚紀念醫院質子暨放射治療中心放射腫瘤部副主任'],
        certification: [
          '中華民國放射線醫學會',
          '台灣放射腫瘤學會',
          '中華民國癌症醫學會',
          '美國放射腫瘤學會',
        ],
        honors: [],
        hr: `${process.env.PUBLIC_URL}/images/hr-2.png`,
        image: `${process.env.PUBLIC_URL}/images/cancer-speaker-2.png`,
        imageMobile: `${process.env.PUBLIC_URL}/images/cancer-speaker-2-m.png`,
        isOpen: false,
      },
      {
        theme: 'blue',
        name: '高偉恆 醫師',
        organization: '林口長庚醫院',
        title: '放射腫瘤科學術組助理教授級主治醫師',
        specialties: ['小兒腫瘤、腦瘤、肺癌、癌症相關流行病學研究'],
        position: ['林口長庚紀念醫院放射腫瘤科助理教授級主治醫師'],
        education: [
          '國立陽明交通大學公共衛生所流行病學組博士班',
          '臺北醫學大學醫學系學士',
        ],
        experience: [
          '北醫萬芳醫院實習醫師',
          '林口長庚紀念醫院放射腫瘤科住院醫師',
          '林口長庚紀念醫院放射腫瘤科總醫師',
          '林口長庚紀念醫院放射腫瘤科一般級主治醫師',
          '林口長庚紀念醫院放射腫瘤科講師級主治醫師',
        ],
        certification: [
          '美國放射腫瘤學會 (ASTRO)',
          '歐洲放射腫瘤學術年會 (ESTRO)',
          '台灣放射腫瘤學會 (TASTRO)',
          '台灣肺癌學會',
        ],
        honors: [],
        hr: `${process.env.PUBLIC_URL}/images/hr-2.png`,
        image: `${process.env.PUBLIC_URL}/images/cancer-speaker-3.png`,
        imageMobile: `${process.env.PUBLIC_URL}/images/cancer-speaker-3-m.png`,
        isOpen: false,
      },
      {
        theme: 'blue',
        name: '陳柏叡 醫師',
        organization: '林口長庚醫院',
        title: '放射腫瘤科主治醫師',
        specialties: [
          '攝護腺癌、泌尿道癌、婦科癌症、甲狀腺癌、立體定位消融放射治療',
        ],
        position: [
          '基隆長庚紀念醫院放射腫瘤科主治醫師',
          '林口長庚紀念醫院放射腫瘤科主治醫師',
        ],
        education: ['長庚大學醫學系'],
        experience: [
          '林口長庚紀念醫院放射腫瘤科主治醫師',
          '林口長庚紀念醫院放射腫瘤科總住院醫師',
          '林口長庚紀念醫院放射腫瘤科住院醫師',
          '台灣駐史瓦濟蘭醫療團醫師',
          '台灣駐聖多美普林西比醫療團醫師',
          '林口長庚紀念醫院 PGY 一般科住院醫師',
          '林口長庚紀念醫院實習醫師',
        ],
        certification: ['台灣放射腫瘤學會', '美國放射腫瘤學會'],
        honors: [],
        hr: `${process.env.PUBLIC_URL}/images/hr-2.png`,
        image: `${process.env.PUBLIC_URL}/images/cancer-speaker-4.png`,
        imageMobile: `${process.env.PUBLIC_URL}/images/cancer-speaker-4-m.png`,
        isOpen: false,
      },
      {
        theme: 'blue',
        name: '王友明 醫師',
        organization: '高雄長庚醫院',
        title: '放射腫瘤部主任及副教授/質子暨放射治療中心主任',
        specialties: [
          '質子治療、鼻咽癌、頭頸癌、食道癌、胸腔腫瘤、兒童腫瘤、腦瘤、立體定位放射手術、電腦刀生理訊號分析、三維導航強度調控質子治療',
        ],
        position: [
          '高雄長庚紀念醫院放射腫瘤部及質子暨放射治療中心主任',
          '高雄長庚紀念醫院副教授級主治醫師',
          '長庚醫院產學合作中心副主任',
          '台灣放射腫瘤學會常務理事',
          '全民健康保險醫藥審查專家',
          '國家實驗研究院 STB 學者',
          'SCI 期刊編輯委員',
          '亞太粒子放射治療合作聯盟 (PTCOG-AO) 學術委員',
        ],
        education: ['國立陽明大學醫學系醫學士'],
        experience: [
          '高雄長庚紀念醫院放射腫瘤部暨尖端癌症治療中心副主任',
          '台灣放射腫瘤學會理事',
          '美國加州史丹福大學-醫療器材產品設計研究員醫師 (STB)',
        ],
        certification: ['台灣放射腫瘤學會專科醫師'],
        honors: [],
        hr: `${process.env.PUBLIC_URL}/images/hr-2.png`,
        image: `${process.env.PUBLIC_URL}/images/cancer-speaker-5.png`,
        imageMobile: `${process.env.PUBLIC_URL}/images/cancer-speaker-5-m.png`,
        isOpen: false,
      },
      {
        theme: 'blue',
        name: '黃英彥 醫師',
        organization: '高雄長庚醫院',
        title: '放射腫瘤部教授級主治醫師',
        specialties: [
          '婦癌、直腸癌、乳癌、肺癌之放射治療',
          '精準放射治療(質子治療、電腦刀立體定位放射治療)',
          '近接放射治療',
          '生物統計學與癌症登記資料庫分析',
          '放射治療效果與副作用之基礎轉譯研究',
          '癌症抗輻射與醣蛋白研究',
        ],
        position: [
          '高雄長庚紀念醫院教授級主治醫師',
          '高雄長庚紀念醫院醫學研究部副主任',
          '高雄長庚紀念醫院生物統計中心主任',
          '國立中山大學後醫學系專任教授 ',
          '台灣放射腫瘤學會監事',
        ],
        education: ['中國醫藥學大學醫學系畢業', '長庚大學臨床醫學研究所博士'],
        experience: [
          '高雄長庚紀念醫院質子暨放射治療中心放射腫瘤主任',
          '高雄長庚紀念醫院癌症中心主任',
          '林口長庚紀念醫院質子暨放射治療中心質子進修醫師',
          '日本國立癌症中心東病院質子進修醫師',
          '台灣癌症登記學會理事/監事',
          '台灣放射腫瘤學會理事',
          '台灣放射腫瘤學會輻射生物學授課教師',
          '長庚大學臨床醫學研究所授課教師',
          '放射治療與腫瘤學期刊編輯委員',
        ],
        certification: ['台灣放射腫瘤學會專科醫師'],
        honors: [],
        hr: `${process.env.PUBLIC_URL}/images/hr-2.png`,
        image: `${process.env.PUBLIC_URL}/images/cancer-speaker-6.png?250806v1`,
        imageMobile: `${process.env.PUBLIC_URL}/images/cancer-speaker-6-m.png?250806v1`,
        isOpen: false,
      },
    ],
  },
];

const useEventStore = create((set) => ({
  activeTab: topicName.heart,
  setActiveTab: (tab) => {
    set({ activeTab: tab });
  },
}));

export default useEventStore;
